import { PureComponent } from 'react';
import * as styles from './styles';
import CustomModal from 'components/CustomModal';
import { InputField }  from 'components/Fields';
import moment from 'moment';

const customStyles = {
  content : {
    width: '483px',
    maxWidth: '483px' 
  }
};


export default class PaymentModal extends PureComponent {

  verifyPatient(id, externalId) {
    let { verifyPatient, closeModal } = this.props;
    verifyPatient(id, externalId);
    closeModal();
  }

  render () {
    let { isOpen, closeModal, i18n, profile = {}, blockPatient } = this.props;
    let umbiProfile = profile.umbi || {}; 

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <styles.ModalCloseIcon onClick={closeModal}/>
        <styles.ModalTitle>{i18n.t('verify_patient_popup_title')}</styles.ModalTitle>
        <styles.ModalText>{i18n.t('verify_patient_popup_text')}</styles.ModalText>
        <styles.Form>
          <InputField
            label={i18n.t('first_name')}
            input={{ value: umbiProfile.firstName || '' }}
            disabled
            isRequired={false} 
            placeholder={i18n.t('first_name')} />
          <InputField
            label={i18n.t('last_name')}
            input={{ value: umbiProfile.lastName || '' }}
            disabled
            isRequired={false} 
            placeholder={i18n.t('last_name')} />
          <InputField
            label={i18n.t('birth_date')}
            input={{ value: umbiProfile.birthDate && moment(umbiProfile.birthDate).format('DD MMM YYYY') || '' }}
            disabled
            isRequired={false} 
            placeholder={i18n.t('birth_date')} />
          <InputField   
            label={i18n.t('email')}
            input={{ value: umbiProfile.email || '' }}
            disabled
            isRequired={false} 
            placeholder={i18n.t('email')} />
          <InputField
            label={i18n.t('mobile_phone')}
            input={{ value: umbiProfile.phone && umbiProfile.phone.replace(/(\d{2})/g, '$1 ').replace(/(^\s+|\s+$)/,'').replace(/^04\s/, '(0)4') || '' }}
            disabled
            isRequired={false} 
            placeholder={i18n.t('mobile_phone')} />  
        </styles.Form>        
        <styles.ModalLine />
        <div style={{ position: 'relative', textAlign: 'right' }}>
          <styles.ModalCancel onClick={closeModal}>{i18n.t('popup_cancel_button')}</styles.ModalCancel>
          <styles.BlockPatientButton onClick={blockPatient}>{i18n.t('block_patient_button')}</styles.BlockPatientButton>
          <styles.ModalButtonConfirm onClick={() => { this.verifyPatient(umbiProfile.id, profile.id); }}>
            {i18n.t('verify_patient_button')}
          </styles.ModalButtonConfirm>
        </div>
      </CustomModal>
    );
  }
}
